<p>
  equipment-addendum works!
</p>
